export default __webpack_public_path__ + "static/media/Pickpocket's Bands of the Fifth Stage.0a67e9b5.jpg";